export default {"src":"/_next/static/media/vivrelle-wordmark-white.44f15e02.svg","height":32,"width":176,"blurWidth":0,"blurHeight":0};